import { InjectionToken } from "@angular/core";

export const PROJECTS_FUNDING_URL = new InjectionToken<string>("Projects funding url");
export const TERMS_OF_USE_URL = new InjectionToken<string>("Terms of use url");
export const ACCESSIBILITY_STATEMENT_URL = new InjectionToken<string>("Accessibility statement url");
export const MISSION_PLANNING_COURSE_URL = new InjectionToken<string>("Mission planning course url");
